
import { Component, Prop, Vue } from 'vue-property-decorator'
import CollaboratorTable from "@/components/Collaborator/CollaboratorTable.vue"
import CollaboratorEdit from "@/components/Collaborator/CollaboratorEdit.vue"
import Collaborator from "@/types/collaborator/Collaborator"

@Component({
  filters: {
  },
  components: {
    CollaboratorEdit,
    CollaboratorTable
  }
})
export default class CollaboratorDashboard extends Vue {
  @Prop({ required: true })
  private dialog!: boolean

  @Prop({ required: true })
  private projectId!: string

  private updateCollaboratorSelected (collaborator: Collaborator) {
    this.$root.$emit('collaboratorGotSelected', collaborator)
  }
}
